import { useOktaAuth } from '@okta/okta-react';
import axios from 'axios';
import { BusinessAddress } from 'models/business';
import { useMutation, useQuery } from 'react-query';


export const useSyncBusinessAddress = () => {
	const { oktaAuth } = useOktaAuth();

	return useMutation<BusinessAddress[], Error, { crmId: string; businessName?: string }>(
		async ({ crmId, businessName }) => {
			const token = await oktaAuth.getIdToken();
			const response = await axios.post<BusinessAddress[]>(
				`${process.env.REACT_APP_API}/Portal/Businesses/SyncBusinessAddress/${crmId}`,
				null,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						business: businessName,
					},
				}
			);
			return response.data;
		},
		{ retry: false }
	);
};